module.exports = __webpack_public_path__ + "static/media/weconsume_hdr.3b68f053.jpg";